import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import VesselSelector from "./components/VesselSelector";
import LoginForm from "./components/LoginForm";
import CrewDashboard from "./components/CrewDashboard";
import ChiefDashboard from "./components/ChiefDashboard";

function StartupGuard() {
  const [loading, setLoading] = useState(true);
  const [redirect, setRedirect] = useState(null);

  useEffect(() => {
    fetch("api/current-vessel/")
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error("No vessel");
      })
      .then((data) => {
        console.log("API response:", data); // 👀 debug
        if (data.vessel_id) {
          localStorage.setItem("selectedVesselId", data.vessel_id);
          sessionStorage.setItem("selectedVesselId", data.vessel_id);
          setRedirect("/login");
        } else {
          setRedirect("/vessel-selector");
        }
      })
      .catch(() => setRedirect("/vessel-selector"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>⏳ Checking vessel...</div>;

  return <Navigate to={redirect} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      <Routes>
        <Route path="/" element={<StartupGuard />} />

        <Route path="/vessel-selector" element={<VesselSelector />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/crew-dashboard" element={<CrewDashboard />} />
        <Route path="/chief-dashboard" element={<ChiefDashboard />} />

        {/*  safer fallback → not loop back to "/" */}
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}
